var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg003A1To2People(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88.71,
    height: 88.709,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 422.096845,
    width: 422.096845,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#777f8e",
    id: "svg_2",
    d: "m48.961926,24.099057c0,-7.870828 6.336205,-14.251057 14.154879,-14.251057s14.154879,6.380229 14.154879,14.251057c0,7.870828 -6.336205,14.251057 -14.154879,14.251057s-14.154879,-6.381201 -14.154879,-14.251057zm20.160038,15.222764l-12.010318,0c-9.993156,0 -18.122608,8.185661 -18.122608,18.245745l0,14.792298l0.037641,0.229323l1.013407,0.31872c9.535675,2.998688 17.822447,4.000518 24.641226,4.000518c13.320025,0 21.040254,-3.824639 21.517038,-4.067566l0.945846,-0.48391l0.100376,0.000972l0,-14.789383c0.000965,-10.061056 -8.128487,-18.246717 -18.122608,-18.246717zm-43.366088,-0.971707c7.817709,0 14.154879,-6.380229 14.154879,-14.251057c0,-7.870828 -6.33717,-14.251057 -14.154879,-14.251057s-14.154879,6.380229 -14.154879,14.251057c0,7.870828 6.33717,14.251057 14.154879,14.251057zm9.966132,34.009751l0,-14.791326c0,-5.889517 2.35979,-11.223218 6.162478,-15.127537c-2.892552,-1.967707 -6.376741,-3.118208 -10.122486,-3.118208l-12.011283,0c-9.993156,-0.000972 -18.123573,8.184689 -18.123573,18.245745l0,14.791326l0.037641,0.229323l1.014372,0.31872c9.53471,2.998688 17.821482,4.000518 24.641226,4.000518c4.336416,0 8.067683,-0.408117 11.160021,-0.96199l-2.337592,-0.736554l-0.420805,-2.850017z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg003A1To2People);
export default __webpack_public_path__ + "static/media/003a-1-to-2-people.574582cf7e829b331e82cb361814cd77.svg";
export { ForwardRef as ReactComponent };